import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const Feet: ConvertableUnit = {
  label: "Feet",
  shortLabel: "ft",
  toStandardUnit: ft => ft,
  toThisUnit: ft => ft
};

export const Inches: ConvertableUnit = {
  label: "Inches",
  shortLabel: "in",
  toStandardUnit: inches => inches / 12,
  toThisUnit: ft => ft * 12
};

export const Meters: ConvertableUnit = {
  label: "Meters",
  shortLabel: "m",
  toStandardUnit: m => m * 3.280839895,
  toThisUnit: ft => ft / 3.280839895
};

export const Centimeters: ConvertableUnit = {
  label: "Centimeters",
  shortLabel: "cm",
  toStandardUnit: cm => cm * 0.03280839895,
  toThisUnit: ft => ft / 0.03280839895
};

export const Millimeters: ConvertableUnit = {
  label: "Millimeters",
  shortLabel: "mm",
  toStandardUnit: mm => mm * 0.003280839895,
  toThisUnit: ft => ft / 0.003280839895
};

export const Yards: ConvertableUnit = {
  label: "Yards",
  shortLabel: "yd",
  toStandardUnit: yd => yd * 3,
  toThisUnit: ft => ft / 3
};

const unitList = [Feet, Inches, Meters, Yards, Centimeters, Millimeters];
export const LengthUnits = {
  Feet,
  Inches,
  Meters,
  Yards,
  Centimeters,
  Millimeters,
  options: buildOptions(unitList)
};

const largeUnitList = [Feet, Inches, Meters, Yards];

export const LargeLengthUnits = {
  Feet,
  Inches,
  Meters,
  Yards,
  options: buildOptions(largeUnitList)
};

const smallUnitList = [Inches, Centimeters, Millimeters];

export const SmallLengthUnits = {
  Inches,
  Centimeters,
  Millimeters,
  options: buildOptions(smallUnitList)
};

export const convertSmallLengthUnits = (
  numberInches: number,
  smallLengthUnit: ConvertableUnit
): number => {
  return Number(
    smallLengthUnit.toThisUnit(Inches.toStandardUnit(numberInches)).toFixed(2)
  );
};
